import React from "react";
import {Avatar, Divider, Spin, Table} from "antd";

import AdminFilters from "../../components/AdminFilters";
import IModalForm from "../../components/IModalForm";
import PartnerForm from "./Form";
import AdminActionDropdown from "../../components/AdminActionDropdown";
import {formatDate} from "../../utils";

function getStatusTitle(status) {
  const statuses =  {
    public: 'Опубліковано',
    draft: 'Черновик',
    deleted: 'Видалено'
  };
  return statuses[status] || 'Не вказано'
}


export default class TournamentsList extends React.Component {

  render() {
    const columns = [
      {
        title: 'Логотип',
        dataIndex: 'file',
        key: 'file',
        render: (t, r) => <Avatar src={r.file.url}/>
      },
      {
        title: 'Назва',
        dataIndex: 'title',
        key: 'title',
      },
      {
        title: 'Посилання',
        dataIndex: 'link',
        key: 'link',
      },
      {
        title: 'Дата початку',
        dataIndex: 'date_started',
        key: 'date_started',
        render: (t, r) => formatDate(t)
      },
      {
        title: 'Дата створення',
        dataIndex: 'date_created',
        key: 'date_created',
        render: (t, r) => formatDate(t)
      },
      {
        title: 'Дата оновлення',
        dataIndex: 'date_updated',
        key: 'date_updated',
        render: (t, r) => formatDate(t)
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        render: (t, r) => getStatusTitle(r.status)
      },
      {
        title: 'Дії',
        dataIndex: 'action',
        key: 'action',
        render: (text, item) => (
          <AdminActionDropdown
            {...this.props}
            item={item}
          />
        ),
      }
    ];
    return (
      <div>
        <h2>Список закордонних турнірів</h2>
        <Divider/>
        <AdminFilters {...this.props} />
        <Table
          columns={columns}
          dataSource={this.props.tournaments}
          rowKey="id"
          loading={this.props.loading}
          locale={{emptyText: "Немає турнірів"}}
        />
        <IModalForm
          title={this.props.editMode ? "Редагувати турнір" : "Додати турнір"}
          showModal={this.props.showModal}
          onCancel={this.props.onCancel}
          onSubmit={this.props.onSubmit}
        >
          <Spin spinning={this.props.loading} size="large">
            <PartnerForm
              {...this.props}
              onChangeInput={this.props.onChangeInput}
            />
          </Spin>
        </IModalForm>
      </div>
    );
  }
}
